import React, { useState } from "react";
import { ConsolePage } from "./pages/ConsolePage";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';
import { decodeJwt } from 'jose';
import "./index.css"; // Add your custom styles if needed.

interface User {
  name: any;
  photoURL: any;
  email: any;
  userId: any;
}

console.log("object")
const Login: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [error, setError] = useState<string | null>(null); // To display errors
  const navigate = useNavigate(); // React Router's navigation

  

 
  // Handle Google login
  const handleSuccess = async (credentialResponse: any) => {
    try {
      console.log("Login Success! Current user:", credentialResponse);
      const { credential } = credentialResponse;
      const userInfo = decodeJwt(credential);
      console.log('User Info:', userInfo);
  
      // Prepare the API request data
      const data = {
        name: userInfo.name,
        email: userInfo.email,
        photo_url: userInfo.picture,
        login_by: "google",
        mobile: "", // optional
        password: "", // optional
        social_id: "" // optional
      };
  
      // Send the request to the custom login API
      const response = await fetch("https://talk.dil.in/api/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        },
        body: JSON.stringify(data),
      });
  
      // Check if the response is OK (status code 200-299)
      if (response.ok) {
        const resultData = await response.json(); // Parse response once
  
        // Check if the API response indicates success
        if (resultData.status === 1) {
          console.log("Login successful:", resultData.data);
        
          //localStorage.setItem('userinfo', JSON.stringify(resultData.data));

          // If API is successful, navigate to ConsolePage
          const today = resultData?.data?.use_date == null ? new Date().toISOString().slice(0, 10):resultData?.data?.use_date;
          const timer = resultData?.data?.use_time == null ? 0:parseInt(resultData?.data?.use_time);
          localStorage.setItem(
            'timerState',
            JSON.stringify({ date: today, timeUsed: timer })
          );

          const simplifiedUserInfo = {
            name: resultData?.data?.name,
            photoURL: resultData?.data?.use_date,
            email: resultData?.data?.email,
            userId: resultData?.data?.id
          };
          localStorage.setItem('userinfo', JSON.stringify(simplifiedUserInfo));

          window.location.href = "/console";
        } else {
          // If the API returns an error status
          setError(`Failed to login: ${resultData.message || "Unknown error"}`);
          console.error("API Login failed. Error:", resultData.message);
        }
      } else {
        // Handle HTTP error
        const errorText = await response.text();
        setError(`Failed to login: ${errorText}`);
        console.error("HTTP error during API call:", errorText);
      }
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Error during Google Login:", error);
      setError("An error occurred during login.");
    }
  };

  const handleError = () => {
    console.log('Login Failed');
  };
  

  // Handle Logout
  const handleLogout = async () => {
    try {
      //await signOut(auth);
      setUser(null);
    } catch (error) {
      console.error("Error during Logout:", error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center login-background">
      <div className="bg-white text-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full opacity-90">
        <div>
          <h1 className="text-3xl font-bold text-center mb-6">
            Rajasthan Virtual Guide
          </h1>
          <p className="text-center text-gray-600 mb-4">
            Your personal voice assistant to explore anything about Rajasthan including rich culture and heritage.
          </p>
          <span className="googleDiv">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
          />
          </span>
          {/* <button
            onClick={handleLogin}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded text-lg font-semibold"
          >
            Login with Google
          </button> */}
          {error && (
            <p className="text-red-500 text-center mt-4">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
